import { render, staticRenderFns } from "./EditorPlayer.vue?vue&type=template&id=359819c3&"
import script from "./EditorPlayer.vue?vue&type=script&lang=js&"
export * from "./EditorPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports